module.exports = __webpack_public_path__ + "img/order9.6e8d4391.png";